import React from 'react';
import {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
  SSO_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  getSingleChoiceValue,
  getTrueFalseSingleChoiceValue,
} from '@r-and-a-shared-ui/common-kontent-client/utils';
import {
  getFirstMappedLinkedItemOrDefault,
  getMappedLinkedItems,
} from './utils/component-mapping-helpers';

type FormFieldModel = SSO_MODELS.FormField &
  MEMBERSHIP_MODELS.FormField &
  PLAYER_PORTALS_MODELS.FormField;

export const form_field = (data: FormFieldModel) => {
  if (!data || !data.elements) {
    console.error('Data or data.elements is undefined:', data);
    return undefined;
  }

  const { elements } = data;

  return {
    fieldType: getSingleChoiceValue(elements?.type) ?? 'text',
    key: data?.system?.codename,
    name: elements?.id?.value || '',
    queryParamKey: elements?.value_from_query_param?.value,
    fieldRef: React.createRef(),
    placeholder: elements?.placeholder?.value,
    label: elements?.label?.value,
    isRequired: getTrueFalseSingleChoiceValue(elements?.is_required),
    isDisabled: getTrueFalseSingleChoiceValue(elements?.is_readonly),
    validationMessage: elements?.validation_message?.value,
    validationRegex: elements?.validation_regex?.value,
    hint: elements?.hint?.value,
    options: getMappedLinkedItems(elements?.options),
    nonEmptyFields: getMappedLinkedItems(elements?.non_empty_fields)?.map(
      (nef: any) => nef?.name,
    ),
    defaultOption: getFirstMappedLinkedItemOrDefault(elements?.default_option),
    defaultOptionMessage: elements?.default_option_message?.value,
    dependsOn: getFirstMappedLinkedItemOrDefault(elements?.depends_on)?.name,
    dependencyCriteria: getSingleChoiceValue(elements?.dependency_criteria),
    dependencyValidationMessage: elements?.dependency_validation_message?.value,
    subfields: getMappedLinkedItems(elements?.subfields),
    preferredOptionsList: getSingleChoiceValue(
      elements?.predefined_options_list,
    ),
    fieldReplacement: getFirstMappedLinkedItemOrDefault(
      elements?.field_replacement,
    ),
    hideIcon: getTrueFalseSingleChoiceValue(elements?.hide_icon),
    entireObjectSelection: getTrueFalseSingleChoiceValue(
      elements?.entire_object_selection,
    ),
    logicalName: elements?.logical_name?.value,
    otherOptionValue: elements?.other_option_value?.value,
    multipleValidation: getMappedLinkedItems(elements?.multiple_validation),
    multipleValidationLabel: elements?.multiple_validation_label?.value,
    uniqueValueSelection: getTrueFalseSingleChoiceValue(
      elements?.unique_value_selection,
    ),
    hiddenClearable: getTrueFalseSingleChoiceValue(elements?.hidden_clearable),
    displayHideFieldBasedOnOtherFieldsValue:
      getMappedLinkedItems(
        elements?.display_or_hide_field_based_on_other_fields_value,
      ) || [],
  };
};

export default form_field;
